var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","icon":""},on:{"click":function($event){return _vm.logout()}}},[_c('v-icon',[_vm._v("mdi-power")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }